module.exports = __webpack_public_path__ + "assets/images/arrow-left-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/arrow-left-on.png
// module id = 1480
// module chunks = 1